import { render, staticRenderFns } from "./TvControl.vue?vue&type=template&id=34c224f2&scoped=true&"
import script from "./TvControl.vue?vue&type=script&lang=js&"
export * from "./TvControl.vue?vue&type=script&lang=js&"
import style0 from "./TvControl.vue?vue&type=style&index=0&id=34c224f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c224f2",
  null
  
)

export default component.exports